<div *ngIf="error" class="text-center p-2" style="color: red">{{ error }}</div>
<button mat-raised-button type="button" (click)="onUpload()" [disabled]="disabled">
  {{ label }}
</button>
